import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-shipping-policy',
  templateUrl: './shipping-policy.component.html',
  styleUrl: './shipping-policy.component.scss',
  imports: [CommonModule],
  schemas: [NO_ERRORS_SCHEMA],
})
export class ShippingPolicyComponent {
  [key: string]: any;
  constructor() {
  }


}
